import lazyLoad from 'app/shared-components/util/lazyLoad';

const VerifyEmailPage = lazyLoad(() => import('./VerifyEmailPage'));

import authRoles from '../../auth/authRoles';

const VerifyEmailConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: 'verify-email',
      element: <VerifyEmailPage />,
    },
  ],
};

export default VerifyEmailConfig;
